import React, { useEffect, useState } from 'react'
import CandidateHeaderComponent from '../Components/CandidateHeaderComponent'
import { CandidateInvitationStats, CandidateProfile } from '../Types/CandidateType';
import { getCandidateById, getInvitationStatsByCandidiateId } from '../Services/CandidateService';
import CandidateInvitationStatsComponent from '../Components/CandidateInvitationStatsComponent';
import CandidateCard from '../Components/CandidateCard';
import CandidateDashboardHeader from '../Components/CandidateDashboardHeader';
import CandidateJobInvitaionListingPage from './CandidateJobInvitaionListingPage';
import { storage } from '../../Shared/Utils/authStorage';

function CandidateDashboard() {

  const [candidate, setCandidate] = useState<CandidateProfile | null>(null);
  const [invitationStats, setInvitationStats] = useState<CandidateInvitationStats | null>(null);
const [loading, setLoading] = useState<boolean>(true);
const [error, setError] = useState<string>("");

useEffect(() => {
  const fetchCandidate = async () => {
    // 1. Get the ID inside the effect to ensure fresh data
    const userId = storage.getUserId();


    // 2. Guard Clause: Don't fetch if there is no ID
    if (!userId) {
      setError("No user ID found. Please log in again.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true); // Ensure loading is true when starting
      const response = await getCandidateById(userId);

      const invitationStats = await getInvitationStatsByCandidiateId(userId);
      if (response.success) {
        setCandidate(response.data);
        setInvitationStats(invitationStats?.data || null);
      } else {
        setError(response.message || "Could not retrieve candidate profile.");
      }
    } catch (err) {
      setError("An unexpected error occurred while loading the profile.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  fetchCandidate();
}, []); // Empty dependency array is fine if using localStorage




return (
  <div className="min-h-screen bg-slate-950 p-6 text-slate-100 selection:bg-cyan-500/30 selection:text-cyan-200">
            {/* <CandidateDashboardHeader candidate={candidate} /> */}

    {/* Main Dashboard Container */}
    <div className="mx-auto max-w-7xl space-y-6 rounded-xl border border-slate-800 bg-slate-900/50 p-6 shadow-2xl shadow-slate-950/50 backdrop-blur-sm">
      
      {/* Header Section */}
      <header className="border-b border-slate-800 pb-5">
      <CandidateDashboardHeader candidate={candidate} />

      </header>

      {/* Stats Quick-View (Conditional Neon Accent Banner) */}
      {invitationStats && (
        <div className="relative overflow-hidden rounded-lg border border-slate-700/60 bg-slate-900 px-4 py-2 shadow-inner before:absolute before:left-0 before:top-0 before:h-full before:w-[3px] before:bg-gradient-to-b before:from-cyan-400 before:via-indigo-500 before:to-fuchsia-500">
          <CandidateInvitationStatsComponent stats={invitationStats} />
        </div>
      )}  
  
      {/* Core Content / Profile Card */}
      {candidate && (
        <main className="rounded-lg border border-slate-800 bg-slate-900/80 p-4 shadow-md transition-all duration-300 hover:border-slate-700/80">
          <CandidateCard candidate={candidate} />
        </main>
      )}

    </div>
  </div>
)
}

export default CandidateDashboard